<template>
	<div class="layout-inner dashbaord">
    <navbar></navbar>
    <div class="layout-container">
      <div class="layout-content">
        <div class="container-fluid flex-grow-1 pg_content_container">
          <div class="learner_dashboard inst_switch">
            <div class="row p-3">
              <div class="col-12 sec_tp_msg ace_sec pg_hd">
                <span>You have signed up to explore these institutions, click on the institution below to start exploring.</span>
              </div>
            </div>
            <div class="row comp_row">
              <div class="col-12">
                <div class="long_row learner_explore_program">
                  <div v-for="(institution, i) in institutions" class="col-12 explore_intro">
                    <div class="pkg_entity_bx programs">
                      <button @click.stop="changeInstitution(institution)" class="ace_sec" :aria-label="'institution ' + institution.name" tabindex="0">
                        <div class="bx_inner">
                          <div class="thumbnail_container" style="background: #fff;">
                            <div class="thumbnail_img" v-if="institution.logo">
                              <img v-bind:src="institution.logo" alt="Institution Logo"></img>
                            </div>
                            <div class="default_thumbnail" v-else>
                              <span class="btn_ic ic-inst"></span>
                            </div>
                          </div>
                          <div class="inst_name">
                            {{institution.title}}
                          </div>
                        </div>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
      <div>
          <b-modal v-model="showSSOModal" title="Log in with your institution" no-close-on-backdrop no-close-on-esc centered>
              <div class="text-center">
                      <div class="float-left mr-3">
                          <div class="fld-label">Looks like you have an account with <b><i>{{ssoInstitutionName}}</i></b></div>
                          <div class="fld-label">Please click on the button below to log in with your <b><i>{{ssoInstitutionName}}</i></b> credentials. </div>
                      </div>
              </div>
              <div slot="modal-footer" class="w-100">
                      <b-button variant="primary" size="sm" class="float-right ml-3" @click="institutionLogin">go to institution login</b-button>
              </div>
          </b-modal>
      </div>


        </div>
      </div>


    </div>
  </div>
</template>

<script>
	import { mapActions } from 'vuex'
  import Navbar from '../../misc/components/./Navbar'

  export default {
  	name: 'institutionSwitch',
    components: {
      Navbar
    },
  	data: () => {
  		return {
        institutions: [],
        showSSOModal: false,
        ssoPath : undefined,
        ssoInstitutionName : '',
        ssoInstitutionLogo : ''
  		}
  	},
    created () {
      this.populateInstitutions()
    },
    methods: {
      ...mapActions([
        'loadAllUserInstitution',
        'loadChangeUserInstitution'
  	  ]),
      async populateInstitutions () {
        this.institutions = await this.loadAllUserInstitution()
      },
      checkSSOEnabled (institution) {
          if(institution.path){
              this.showSSOModal = true
              this.ssoPath = institution.path
              this.ssoInstitutionName = institution.title
              this.ssoInstitutionLogo = institution.logo
              return true
          }
          return false
      },
      institutionLogin () {
          window.location.href = window.location.origin + '/sso/' + this.ssoPath
      } ,
      changeInstitution (institution) {
          if(this.checkSSOEnabled(institution)){
              return
          }
        this.loadChangeUserInstitution(institution.uuid).then(res => {
          let status = res.status
          let userObj = res.data
          if (status === 200) {
            return this.$router.push({name: 'dashboard'})
          }
        })
      }
    }
  }
</script>

<style scoped>
  .inst_name {
    text-align: center;
    margin-top: 15px;
    float: left;
    width: 100%;
    font-weight: 600;
    color: #303030;
  }
  .thumbnail_container .thumbnail_img {
    background: #fff;
    width: 70%;
    display: block;
    margin: 0 auto;
    position: relative;
  }
  .thumbnail_container .thumbnail_img img {
    position: absolute;
    margin: auto;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    max-width: 100%;
  }
</style>


// WEBPACK FOOTER //
// src/app/dashboard/components/InstitutionSwitch.vue